import React from 'react';
import {DrawerDetail as Drawers} from 'components/customer/Job/store/jobApi';
import LabelValue from 'components/customer/PDF/components/LabelValue';

const DrawerDetail = ({drawers}: {drawers: Drawers[] | string}) => {
    return (
        <>
            <div className="hr mt-5" />
            <section>
                <div className="font-sm mt-5">
                    <strong>DRAWER DETAIL:</strong>
                </div>
                {Array.isArray(drawers) ? (
                    drawers.map((drawer, i) => {
                        const hasBottomPos = !!drawer.DrawerPositionToBottom;
                        const runnerDetails = `Runner: ${drawer.MaterialName}:${drawer.DrawerRunnerHeight}x${drawer.DrawerRunnerDepth}`;
                        const drawerDetails = hasBottomPos
                            ? [
                                  runnerDetails,
                                  `Position to bottom: ${drawer.DrawerPositionToBottom}`,
                              ]
                            : [
                                  `Face Height:${drawer.DrawerFaceHeight}`,
                                  runnerDetails,
                              ];

                        return (
                            <div
                                // eslint-disable-next-line react/no-array-index-key -- no unique key
                                key={`${drawer.DrawerPrefix}${i}`}
                                className="flex-col mt-5">
                                <LabelValue
                                    inline
                                    labelMinWidth={125}
                                    label={`${hasBottomPos ? 'INNER ' : ''}DRAWER ${i + 1}`}
                                    value={drawerDetails.join('; ')}
                                />
                            </div>
                        );
                    })
                ) : (
                    <div className="mt-5">
                        <LabelValue label="DETAIL" value={drawers} />
                    </div>
                )}
            </section>
        </>
    );
};

export default DrawerDetail;
